import React from 'react';
import './PhonePark.css';

import Icon from '../../../components/Icon/Icon';

const phonePark = ( props ) => (
	<section id="PhonePark">
		<div className="section">
			<div className="inner-section">
				<p>
					You can use the Park feature to put a call on hold so someone else can pick it up.
				</p>
				<p>
					To place a call on Park, press the Park key once (make sure the light next to it isn't already on!).
				</p>
				<p>
					To pick up a call on Park, press the Park key twice.
				</p>
			</div>
			<Icon icon="communication.parkedCall" title="Parked Call" gradient="vertical invert" />
		</div>
	</section>
);

export default phonePark;



// WEBPACK FOOTER //
// ./src/pages/Communication/PhonePark/PhonePark.js